<div class="mb-6 bg-white p-4 lg:p-8">
  <ng-content></ng-content>
</div>
